import { memo } from 'react';
import { T } from '../../../translation/src';
import { PropertiesSection, Property } from './PropertiesSection';
import { PropertyPanel } from '../../Properties/components/PropertyPanel';
import { AnnotationType } from '../../Properties/types';
import { getWallSketchNodesProperty, getWallSketchEdgesProperty } from '@pointorama/potree-shared';
import { usePropertyValue } from '../../Properties/reactive/usePropertyValue';

interface WallSketchPropertiesProps {
  identifier: string;
  projectId: string;
}

const WallSketchProperties_: React.FC2<WallSketchPropertiesProps> = ({ identifier, projectId }) => {
  const nodes = usePropertyValue(getWallSketchNodesProperty(identifier));
  const edges = usePropertyValue(getWallSketchEdgesProperty(identifier));

  const numberOfNodes = nodes?.length ?? 0;
  const numberOfEdges = edges?.length ?? 0;

  return (
    <div className="flex flex-col space-y-4 divide-y divide-gray-800">
      <PropertiesSection title={<T _str="information" swc />}>
        <Property title={<T _str="type" swc />}>
          <T _str="skeleton" swc />
        </Property>
        <Property title={<T _str="nodes" swc />}>{numberOfNodes}</Property>
        <Property title={<T _str="edges" swc />}>{numberOfEdges}</Property>
      </PropertiesSection>
      <PropertyPanel projectId={projectId} annotationTypes={[AnnotationType.WALL_SKETCH]} objectIdentifiers={[identifier]} />
    </div>
  );
};

export const WallSketchProperties = memo(WallSketchProperties_);
